import { useTranslation } from 'react-i18next'
import { generatePath } from 'react-router'
import { Swiper, SwiperSlide } from 'swiper/react'

import { BlogPost, TextMaterialCategory } from '@entities/Blog'

import { URL_BLOG_POST } from '@shared/contants'
import { LocalizedLink as Link } from '@shared/lib/locale'
import ArticleCard from '@shared/ui/aritcle-card'
import Button from '@shared/ui/button'

import BlogEmpty from './empty'

import styles from './styles.module.scss'

type BlogListProps = {
  currentCategorySlug?: string;
  showCategories?: boolean;
  categories?: TextMaterialCategory[];
  articles: BlogPost[];
  onCategoryChange: (category?: TextMaterialCategory) => void;
};

export default function BlogList ({
  currentCategorySlug,
  showCategories = true,
  categories = [],
  articles,
  onCategoryChange,
}: BlogListProps) {
  const { t: tb } = useTranslation('blog')

  if (!articles || articles.length === 0) {
    return <BlogEmpty />
  }

  return (
    <div className={styles.root}>
      <div className={styles.root__top}>
        <h2 className={styles.root__title}>{tb('blog')}</h2>
        {showCategories && (
          <Swiper
            className={styles.root__slider}
            slidesPerView="auto"
            spaceBetween={8}
          >
            <SwiperSlide className={styles.root__slide}>
              <Button
                className={styles.root__buttonFilters}
                theme={currentCategorySlug ? 'grey' : 'primary'}
                onClick={() => onCategoryChange(undefined)}
              >
                {tb('categories.all')}
              </Button>
            </SwiperSlide>
            {categories.map((el, i) => (
              <SwiperSlide
                className={styles.root__slide}
                key={`${el?.title}-${i}`}
              >
                <Button
                  className={styles.root__buttonFilters}
                  theme={currentCategorySlug !== el?.slug ? 'grey' : 'primary'}
                  key={el?.slug}
                  onClick={() => onCategoryChange(el)}
                >
                  {el?.title}
                </Button>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>
      
      {/* Featured: первые 3 карточки */}
      <div className={styles.root__featured}>
        {articles.slice(0, 3).map((item, index) => {
          const postLink = generatePath(URL_BLOG_POST, {
            categorySlug: item?.category?.slug || '',
            slug: item?.slug || '',
          })

          return (
            <div 
              className={index === 0 ? styles.root__featuredMain : styles.root__featuredSide} 
              key={item?.id}
            >
              <Link to={postLink}>
                <ArticleCard isBigCard={index === 0} data={item} />
              </Link>
            </div>
          )
        })}
      </div>

      {/* Остальные карточки по 3 в ряд */}
      {articles.length > 3 && (
        <div className={styles.root__grid}>
          {articles.slice(3).map((item) => {
            const postLink = generatePath(URL_BLOG_POST, {
              categorySlug: item?.category?.slug || '',
              slug: item?.slug || '',
            })

            return (
              <div className={styles.root__item} key={item?.id}>
                <Link to={postLink}>
                  <ArticleCard data={item} />
                </Link>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}
